(function () {
    'use strict';
    angular
    .module("app")
    .controller('StudiesController', StudiesController);

    StudiesController.$inject = ['$scope', '$rootScope', 'ModelController', 'Study'];

    function StudiesController($scope, $rootScope, ModelController, Study) {
        $scope.searchEnabled = $(window).outerHeight() >= 720;

        var options = {propertyName: "id", reverse: true, quantity: 50};
        var defaultModel = {
            name: ""
        };
        var settings = {
            defaultModel: defaultModel
        }

        $scope.Studies = new ModelController(Study, options, settings);
        $rootScope.searchBox.link($scope.Studies.list);
    }
})();
